import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Car } from 'app/models/car.model';
import { Company } from 'app/models/company.model';
import { Poligon } from 'app/models/poligon.model';
import { UserUpdate } from 'app/models/user-update.model';
import { User } from 'app/models/user.model';
import { CarService } from 'app/services/car.service';
import { CompanyService } from 'app/services/company.service';
import { PoligonService } from 'app/services/poligon.service';
import { ToasterService } from 'app/services/user-interaction/services/toaster.service';
import { UserService } from 'app/services/user.service';
import { th } from 'date-fns/locale';
import { BaseFormComponent } from "../../base-form.component";

@Component({
    selector: 'app-user-form',
    templateUrl: './user-form.component.html',
    styleUrls: ['./user-form.component.scss']
})
export class UserFormComponent extends BaseFormComponent implements OnInit {
    private _user: User = {
        role: 0,
        active: 1
    }
    public MasterUser:User;
    public userList:Array<User>;
    public companyId: number;
    public company: Array<Company> = [];
    public passChange = true //"Değiştir"
    public fileStatus = true //"Değiştir"
    public fileData: File[] = []
    public status: string
    private _npass: string
    public get npass() {
        return this._npass
    }
    public set npass(v: string) {
        this._npass = v
    }
    private _userUpdate: UserUpdate = {}
    public set UpdateModel(v: UserUpdate) {
        this._userUpdate = v
    }
    public get UpdateModel() {
        return this._userUpdate
    }
    public get model() {
        return this._user
    }
    public set model(v: User) {
        this._user = v;
    }
    constructor(
        private _userService: UserService,
        private _companyService: CompanyService,
        private _toasterService: ToasterService,
        private _translateService:TranslateService
    ) {
        super();
    }


    public async ngOnInit() {
        try {
            this.company = await this._companyService.getCompanies();
            this.status = this.operation;
            this.companyId= parseInt(localStorage.getItem("CompanyID"))
            if(this.operation == "update"){
                this.MasterUser=this.model;
            }
        } catch (error) {
            console.warn(error);
        }

        try {
            this.userList = await this._userService.getUser()
            
        } catch (error) {
            console.warn(error);
            
        }

    }

    public fileChange(f) {
        try {
            this.fileData.push(f[0])

        } catch (error) {
            console.warn(error);

        }
    }



    public async save() {
        if (this.form.invalid) {
            this._toasterService.toastWarning(
                this._translateService.instant("PLEASE_FILL_IN_THE_FORM_CORRECTLY")
            );
            return;
        }
        var control = this.userList.find(x=>x.userName==this.model.userName && this.model.userName != this.MasterUser.userName)
        if(control){
            this._toasterService.toastWarning(this._translateService.instant("THIS_USERNAME_IS_IN_USE_PLEASE_ENTER_A_DIFFERENT_USERNAME"))
            return;
        }
        //Create
        this.model.status = true;
        this.model.active = parseInt(this.model.active.toString())
        this.model.role = parseInt(this.model.role.toString())
        if (parseInt(localStorage.getItem("RoleID")) != -1) {//is not super admin
            this.model.companyId = this.companyId;
        }
        if (this.operation == "create") {
            //File Select
            if (this.fileData.length == 0) {
                try {
                    await this._userService.add(this.model);
                    this.added.emit(true);
                } catch (error) {
                    console.warn(error);
                    this.added.emit(false);
                }
            }
            //File Unselect
            else {
                const formData = new FormData();
                formData.append("files", this.fileData[0])
                try {
                    let uresponse = await this._userService.upload(formData)
                    this.model.picture = uresponse.toString();
                    if (uresponse[0] != null) {
                        await this._userService.add(this.model);
                        this.added.emit(true);
                    }

                } catch (error) {
                    console.warn(error);
                    this.added.emit(false);

                }
            }
        }
        //Update
        else {
            this.UpdateModel.status = true;
            this.UpdateModel.companyId = this.model.companyId
            this.UpdateModel.active = parseInt(this.model.active.toString()),
                this.UpdateModel.role = parseInt(this.model.role.toString()),
                this.UpdateModel.password = this.model.password
            this.UpdateModel.id = this.model.id,
                this.UpdateModel.name = this.model.name,
                this.UpdateModel.title = this.model.title,
                this.UpdateModel.userName = this.model.userName
            //File Select
            if (this.fileData.length != 0 && !this.fileStatus) {
                if (this.model.picture != '') {
                    try {
                        await this._userService.ImageDelete(this.model)

                    } catch (error) {
                        console.warn(error);

                    }
                }
                // Password Unselect
                if (!this.passChange) {
                    this.UpdateModel.NewPassword = this.model.password
                }
                const formData = new FormData();
                formData.append("files", this.fileData[0]);
                try {
                    let uresponse = await this._userService.upload(formData);
                    this.UpdateModel.picture = uresponse.toString();
                    let response = await this._userService.updated(this.UpdateModel);
                    this.updated.emit(true);


                } catch (error) {
                    console.warn(error);
                    this.updated.emit(false);
                }
            }
            //File Unselect
            else {
                this.UpdateModel.picture = this.model.picture;
                // Password Unselect
                if (this.passChange) {
                    this.UpdateModel.NewPassword = this.model.password;
                }
                try {
                    let response = await this._userService.updated(this.UpdateModel);
                    if (response) {
                        this.updated.emit(true);
                    }
                    else{
                        this.updated.emit(false);
                        return;
                    }

                } catch (error) {
                    console.warn(error);
                    this.updated.emit(false);

                }

            }
        }
    }

}
